import { Flex, Text } from "@radix-ui/themes";
import { TopicType } from "./TopicsList.shared.types";

interface EmptyStateProps {
  searchQuery: string;
  selectedType: TopicType;
  isCollapsed?: boolean;
}

export const EmptyState = ({
  searchQuery,
  selectedType,
  isCollapsed = false,
}: EmptyStateProps) => {
  if (isCollapsed) return null;

  const getMessage = () => {
    if (searchQuery) {
      return `No topics found matching "${searchQuery}"`;
    }

    switch (selectedType) {
      case "live":
        return "No live topics found";
      case "new":
        return "No new topics available";
      case "updates":
        return "No topics with updates";
      case "untrained":
        return "No untrained topics found";
      default:
        return "No topics available";
    }
  };

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      py="6"
      gap="2"
      style={{
        color: "var(--gray-9)",
        textAlign: "center",
        minHeight: "100px",
      }}
    >
      <Text size="2">{getMessage()}</Text>
      {searchQuery && (
        <Text size="1" color="gray">
          Try adjusting your search or filter criteria
        </Text>
      )}
    </Flex>
  );
};
